
// CookieButton.js
import React, { useEffect }  from 'react';
//import DOMPurify from 'dompurify';


const CookieButton = ({ cookieButtonLabel = ''}) => {

	useEffect(() => {
		window.applicationReInit(['CookieHandler']);
	}, []);
	

	return (
		<div className="onetrust-cookie-settings">
			<button className="c-button optanon-toggle-display" data-component-id="root/parsys/onetrust_cookie_sett">{cookieButtonLabel}</button>
		</div>
	)
};

export default CookieButton;



